/* ts-search.js — Typsy persistent search bar */
(function () {
  'use strict';
  var STORAGE_KEY = 'ts_recent_searches';
  var MAX_RECENT = 5;
  // This store has NO GTM container — GA4 (G-NQWNQQ7VPL) is loaded via the
  // Shopify-managed Google tag (GT-MK48VRP) and gtag.js. So we send search
  // events straight to GA4 with gtag(); send_to scopes them to GA4 only (keeps
  // them out of Google Ads). Verified: direct gtag('event') reaches /g/collect.
  var GA4_ID = 'G-NQWNQQ7VPL';
  function ga4(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        var p = params || {};
        p.send_to = GA4_ID;
        window.gtag('event', name, p);
      }
    } catch (e) {}
  }

  function trackSearch(term, source) {
    term = (term || '').trim();
    if (!term) return;
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') { Shopify.analytics.publish('search_submitted', { searchResult: { query: term } }); } } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'search_submit', search_term: term, search_source: source }); } catch (e) {}
    ga4('search_submit', { search_term: term, search_source: source });
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Search', { search_string: term }); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('set', 'search_term', term); } catch (e) {}
  }
  function trackPredictiveClick(term, item) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'predictive_click', search_term: term, item_url: item && item.url, item_type: item && item.type }); } catch (e) {}
    ga4('predictive_click', { search_term: term, item_url: item && item.url, item_type: item && item.type });
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Search', { search_string: term }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') { Shopify.analytics.publish('search_submitted', { searchResult: { query: term } }); } } catch (e) {}
  }

  // NOTE: we deliberately do NOT fire `view_search_results` here. GA4's native
  // Enhanced Measurement "Site search" already emits it for every /search?q= page
  // (and has history). Firing our own would double-count. Chip→collection clicks
  // that never hit ?q= are captured instead by `search_submit` (search_source).

  function getRecent() { try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch (e) { return []; } }
  function setRecent(arr) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr.slice(0, MAX_RECENT))); } catch (e) {} }
  function pushRecent(term) { term = (term || '').trim(); if (!term) return; var arr = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); }); arr.unshift(term); setRecent(arr); }
  function removeRecent(term) { setRecent(getRecent().filter(function (t) { return t !== term; })); }
  function clearRecent() { setRecent([]); }

  // Shared dimming scrim behind the open panel (distinguishes overlay from page)
  var _scrim = null;
  function getScrim() {
    if (_scrim) return _scrim;
    _scrim = document.createElement('div');
    _scrim.className = 'ts-search__scrim';
    _scrim.hidden = true;
    _scrim.addEventListener('click', function () {
      document.querySelectorAll('[data-ts-panel]').forEach(function (p) { p.hidden = true; });
      document.body.classList.remove('ts-search-active');
      _scrim.hidden = true;
      // drop focus too, or the next tap on the bar will not fire 'focus' and the panel stays shut
      var ae = document.activeElement; if (ae && ae.matches && ae.matches('[data-ts-input]')) ae.blur();
    });
    document.body.appendChild(_scrim);
    return _scrim;
  }
  function showScrim() { getScrim().hidden = false; }
  function hideScrim() { if (_scrim) _scrim.hidden = true; }

  // Curated category vocabulary for compound-typo splitting ("mattelip" -> "matte lip").
  // Used by extractQuerySuggestions pass 2. Works even when the typo returns zero products,
  // and avoids the noise of mining live product tags. Keep single words only.
  var TS_VOCAB = (function () {
    var words = ['lip','lips','balm','gloss','glossy','tint','tinted','stain','matte','kajal',
      'liner','eyeliner','eye','kohl','oil','mascara','blush','cloud','peptide','cocoa','pout',
      'polish','twist','plump','plumping','shade','shimmer','glacier','glow','concealer',
      'foundation','foundcealer','cream','lipstick','lipgloss','lipoil','lipbalm','nude','mini',
      'duo','combo','serum','primer','gel','velvet','satin','pencil','brow'];
    var m = {};
    for (var i = 0; i < words.length; i++) m[words[i]] = 1;
    return m;
  })();
  // Product variant index (handle -> [variant_count, default_variant_id]); loaded once, lazily.
  var TS_INDEX = null, TS_INDEX_TRIED = false;
  function loadIndex() {
    if (TS_INDEX || TS_INDEX_TRIED) return;
    TS_INDEX_TRIED = true;
    var u = window.TS_SEARCH && window.TS_SEARCH.indexUrl;
    if (!u) return;
    fetch(u, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { TS_INDEX = j || {}; })
      .catch(function () {});
  }

  function initWidget(root) {
    var input = root.querySelector('[data-ts-input]');
    var form = root.querySelector('[data-ts-form]');
    var panel = root.querySelector('[data-ts-panel]');
    var recentWrap = root.querySelector('[data-ts-recent]');
    var recentList = root.querySelector('[data-ts-recent-list]');
    var sectionsWrap = root.querySelector('[data-ts-sections]');
    var predictive = root.querySelector('[data-ts-predictive]');
    var clearBtn = root.querySelector('[data-ts-clear]');

    var terms; try { terms = JSON.parse(input.getAttribute('data-ts-placeholders') || '[]'); } catch (e) { terms = []; }
    terms = terms.map(function (t) { return (t || '').trim(); }).filter(Boolean);
    var rotationMs = parseInt(root.getAttribute('data-rotation-ms'), 10) || 3000;
    var typewriter = root.getAttribute('data-typewriter') === 'true';

    var idx = 0, rotTimer = null, typeTimer = null;
    function setPlaceholder(t) { input.setAttribute('placeholder', 'search for ' + t); }
    function clearTimers() { if (rotTimer) { clearTimeout(rotTimer); rotTimer = null; } if (typeTimer) { clearTimeout(typeTimer); typeTimer = null; } }
    function nextTerm() {
      if (input.value || document.activeElement === input || !terms.length) return;
      var term = terms[idx % terms.length]; idx += 1;
      if (typewriter) {
        var i = 0;
        function typeChar() { input.setAttribute('placeholder', 'search for ' + term.slice(0, i)); if (i < term.length) { i += 1; typeTimer = setTimeout(typeChar, 55); } else { rotTimer = setTimeout(nextTerm, rotationMs); } }
        typeChar();
      } else { setPlaceholder(term); rotTimer = setTimeout(nextTerm, rotationMs); }
    }
    if (terms.length) { setPlaceholder(terms[0]); idx = 1; rotTimer = setTimeout(nextTerm, rotationMs); }

    function renderRecent() {
      var arr = getRecent();
      if (!arr.length) { recentWrap.hidden = true; return; }
      recentWrap.hidden = false;
      recentList.innerHTML = arr.map(function (t) {
        var safe = t.replace(/"/g, '&quot;').replace(/</g, '&lt;');
        return '<span class="ts-search__chip">' +
          '<button type="button" class="ts-search__chip-text" data-ts-suggest="' + safe + '">' + safe + '</button>' +
          '<button type="button" class="ts-search__chip-x" data-ts-recent-remove="' + safe + '" aria-label="Remove">×</button>' +
          '</span>';
      }).join('');
    }

    function openPanel() {
      loadIndex();
      loadReco();
      prewarmSuggest();
      renderRecent();
      panel.hidden = false;
      document.body.classList.add('ts-search-active');  // lifts sticky header above carousel arrows
      showScrim();
      if (input.value.trim().length >= 2) { showPredictive(); } else { showStatic(); }
    }
    function closePanel() { panel.hidden = true; document.body.classList.remove('ts-search-active'); hideScrim(); }
    function showStatic() {
      if (predictive) predictive.hidden = true;
      if (sectionsWrap) sectionsWrap.style.display = '';
      if (recentWrap && getRecent().length) recentWrap.hidden = false;
    }
    function showPredictive() {
      if (sectionsWrap) sectionsWrap.style.display = 'none';
      if (recentWrap) recentWrap.hidden = true;
      if (predictive) { predictive.hidden = false; fetchSuggest(input.value.trim()); }
    }

    var lastReq = 0;
    var currentQuery = '';
    var suggestCache = {};      // q -> merged results (instant on backspace/retype)
    var suggestCacheKeys = [];  // FIFO, capped
    var suggestAbort = null;    // AbortController for the in-flight pair
    var warmed = false;
    // Prewarm Shopify's predictive endpoint + keep-alive on first panel open, so the
    // FIRST real keystroke doesn't eat the cold-start round-trip. Result is discarded.
    function prewarmSuggest() {
      if (warmed) return; warmed = true;
      try { fetch('/search/suggest.json?q=lip&resources[type]=product&resources[limit]=1', { headers: { 'Accept': 'application/json' } }).catch(function () {}); } catch (e) {}
    }
    function paintSuggest(resultsHost, merged) {
      resultsHost.innerHTML = renderSuggest(merged);
      resultsHost.className = 'ts-search__predictive-results' + (merged.products.length ? ' ts-has-products' : '');
    }
    function fetchSuggest(q) {
      if (!predictive) return;
      var resultsHost = predictive.querySelector('#ts-predictive-results');
      if (!resultsHost) return;
      var reqId = ++lastReq;
      currentQuery = q;
      // Cache hit → render instantly, no network (common on backspace / re-type)
      if (suggestCache[q]) { paintSuggest(resultsHost, suggestCache[q]); return; }
      if (!resultsHost.innerHTML) resultsHost.innerHTML = '<div class="ts-sg__empty">Searching…</div>';
      // Abort the previous in-flight pair so stale requests don't hog the mobile pipe
      if (suggestAbort) { try { suggestAbort.abort(); } catch (e) {} }
      suggestAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var sig = suggestAbort && suggestAbort.signal;
      // NOTE: resources[limit] is a TOTAL cap across all types, so a single mixed
      // request starves products. Split: one call for products, one for collections/articles/pages.
      var base = '/search/suggest.json?q=' + encodeURIComponent(q);
      var pUrl = base + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      var cUrl = base + '&resources[type]=query,collection,article,page&resources[limit]=8';
      var jget = function (u) { return fetch(u, { headers: { 'Accept': 'application/json' }, signal: sig }).then(function (r) { return r.json(); }).catch(function () { return null; }); };
      Promise.all([jget(pUrl), jget(cUrl)]).then(function (out) {
        if (reqId !== lastReq) return;  // a newer query superseded this one
        var pr = (out[0] && out[0].resources && out[0].resources.results) || {};
        var cr = (out[1] && out[1].resources && out[1].resources.results) || {};
        var merged = {
          products: pr.products || [],
          queries: cr.queries || [],
          collections: cr.collections || [],
          articles: cr.articles || [],
          pages: cr.pages || []
        };
        // Cache only real responses (out[0] null = aborted/failed → don't poison cache)
        if (out[0]) {
          suggestCache[q] = merged;
          suggestCacheKeys.push(q);
          if (suggestCacheKeys.length > 30) { delete suggestCache[suggestCacheKeys.shift()]; }
        }
        paintSuggest(resultsHost, merged);
      });
    }
    function extractQuerySuggestions(q, products) {
      if (!q) return [];
      products = products || [];  // pass 2 (vocab compound-split) works even with 0 products
      var qLower = q.toLowerCase().trim();
      if (qLower.length < 2) return [];
      var counts = {};
      var STOP = { 'the':1,'and':1,'for':1,'with':1,'of':1,'a':1,'an':1,'in':1,'on':1,'by':1,'to':1,'is':1,'at':1 };
      // Pass 1: prefix-match on title words (original behaviour)
      products.forEach(function (p) {
        var title = (p.title || '').toLowerCase();
        title = title.replace(/[\(\)\[\]\|,]/g, ' ').replace(/\s+/g, ' ').trim();
        var words = title.split(' ');
        for (var i = 0; i < words.length; i++) {
          var w = words[i];
          if (w.indexOf(qLower) !== 0) continue;
          if (w !== qLower && w.length <= 18 && !STOP[w]) { counts[w] = (counts[w] || 0) + 2; }
          if (i + 1 < words.length && !STOP[words[i+1]]) {
            var phrase2 = w + ' ' + words[i+1];
            if (phrase2.length <= 28) counts[phrase2] = (counts[phrase2] || 0) + 3;
          }
        }
      });
      var keys = Object.keys(counts);
      keys.sort(function (a, b) { if (counts[b] !== counts[a]) return counts[b] - counts[a]; return a.length - b.length; });
      var kept = [];
      for (var k = 0; k < keys.length && kept.length < 6; k++) {
        var cand = keys[k];
        var redundant = kept.some(function (x) { return cand.indexOf(x) === 0 && cand !== x; });
        if (!redundant) kept.push(cand);
      }
      // Pass 2: compound-split for no-space typos (e.g. "mattelip" -> "matte lip").
      // Only runs when pass 1 found nothing. Token set = curated TS_VOCAB plus clean title
      // words from any returned products. Checks forward (q = token + remainder) and reverse
      // (q = prefix + token). Vocab-based so it works even when the typo returns 0 products.
      if (!kept.length && qLower.length >= 5) {
        var tokenSet = {};
        for (var v in TS_VOCAB) tokenSet[v] = 1;
        products.forEach(function (p) {
          (p.title || '').toLowerCase().replace(/[\(\)\[\]\|,\-]/g, ' ').split(/\s+/).forEach(function (w) {
            if (w.length >= 3 && !STOP[w]) tokenSet[w] = 1;
          });
        });
        var seen = {};
        Object.keys(tokenSet).forEach(function (t) {
          // Forward: qLower = t + remainder
          if (qLower.indexOf(t) === 0 && qLower.length > t.length) {
            var rem = qLower.slice(t.length);
            if (rem.length >= 3 && tokenSet[rem]) { var f = t + ' ' + rem; if (!seen[f]) { seen[f] = 1; kept.push(f); } }
          }
          // Reverse: qLower = prefix + t
          var prefixLen = qLower.length - t.length;
          if (prefixLen >= 3 && qLower.slice(prefixLen) === t) {
            var pre = qLower.slice(0, prefixLen);
            if (tokenSet[pre]) { var rv = pre + ' ' + t; if (!seen[rv]) { seen[rv] = 1; kept.push(rv); } }
          }
        });
        kept = kept.slice(0, 4);
      }
      return kept;
    }
    function handleFromUrl(u) {
      if (!u) return '';
      var m = String(u).split('/products/')[1];
      return m ? m.split('?')[0].split('#')[0] : '';
    }
    function hasDiscount(p) {
      var was = parseFloat(p.compare_at_price_max || p.compare_at_price || 0);
      var now = parseFloat(p.price_max || p.price || 0);
      return was > now && now > 0;
    }
    function renderCard(p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      var handle = handleFromUrl(p.url);
      var now = p.price_max || p.price;
      var badge = '';
      if (p.tags && p.tags.length) {
        for (var i = 0; i < p.tags.length; i++) {
          var t = String(p.tags[i]).toLowerCase();
          if (t.indexOf('best') === 0 || t === 'bestseller' || t === 'best seller') { badge = 'Best Seller'; break; }
          if (t === 'new' || t.indexOf('new ') === 0) { badge = 'New'; break; }
        }
      }
      var priceHtml = '<span class="ts-card__price-now">' + formatMoney(now) + '</span>';
      if (hasDiscount(p)) priceHtml = '<span class="ts-card__price-was">' + formatMoney(p.compare_at_price_max || p.compare_at_price) + '</span>' + priceHtml;
      // Button: multi-variant -> "Choose Option" (link to PDP); single/unknown -> "Add to Cart"
      var entry = TS_INDEX && TS_INDEX[handle];
      var btn;
      if (entry && entry[0] > 1) {
        btn = '<a href="' + p.url + '" class="ts-card__atc ts-card__atc--select" data-ts-product>Pick Your Shade</a>';
      } else if (entry && entry[0] === 1) {
        btn = '<button type="button" class="ts-card__atc" data-ts-atc data-ts-variant-id="' + entry[1] + '" data-ts-handle="' + esc(handle) + '" data-ts-url="' + esc(p.url) + '">Add to Cart</button>';
      } else {
        btn = '<button type="button" class="ts-card__atc" data-ts-atc data-ts-handle="' + esc(handle) + '" data-ts-url="' + esc(p.url) + '">Add to Cart</button>';
      }
      return '<div class="ts-card">' +
        '<a href="' + p.url + '" class="ts-card__media" data-ts-product>' +
          (img ? '<img src="' + img + '" loading="lazy" alt="" />' : '') +
          (badge ? '<span class="ts-card__badge">' + badge + '</span>' : '') +
        '</a>' +
        '<div class="ts-card__body">' +
          '<a href="' + p.url + '" class="ts-card__title" data-ts-product>' + esc(p.title) + '</a>' +
          '<div class="ts-card__price">' + priceHtml + '</div>' +
          btn +
        '</div>' +
      '</div>';
    }
    // ── Empty-state Recommended row: client-rendered on first open from the native
    //    /collections/{handle}/products.json endpoint. Zero per-page Liquid cost. ──
    function recoImg(src) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=220'; }
    function renderRecoCard(p) {
      var v = (p.variants && p.variants[0]) || {};
      var url = '/products/' + p.handle;
      var img = recoImg((p.images && p.images[0] && p.images[0].src) || '');
      var now = v.price, was = v.compare_at_price;
      var disc = was && parseFloat(was) > parseFloat(now) && parseFloat(now) > 0;
      var badge = '', tags = p.tags || [];
      for (var i = 0; i < tags.length; i++) {
        var t = String(tags[i]).toLowerCase();
        if (t.indexOf('best') === 0 || t === 'bestseller' || t === 'best seller') { badge = 'Best Seller'; break; }
        if (t === 'new' || t.indexOf('new ') === 0) { badge = 'New'; break; }
      }
      var priceHtml = '<span class="ts-card__price-now">' + formatMoney(now) + '</span>';
      if (disc) priceHtml = '<span class="ts-card__price-was">' + formatMoney(was) + '</span>' + priceHtml;
      var multi = (p.variants || []).length > 1;
      var btn = multi
        ? '<a href="' + url + '" class="ts-card__atc ts-card__atc--select" data-ts-product>Pick Your Shade</a>'
        : '<button type="button" class="ts-card__atc" data-ts-atc data-ts-variant-id="' + v.id + '" data-ts-handle="' + esc(p.handle) + '" data-ts-url="' + esc(url) + '">Add to Cart</button>';
      return '<div class="ts-card ts-card--reco">' +
        '<a href="' + url + '" class="ts-card__media" data-ts-product>' +
          (img ? '<img src="' + img + '" loading="lazy" alt="" width="220" height="220" />' : '') +
          (badge ? '<span class="ts-card__badge">' + badge + '</span>' : '') +
        '</a>' +
        '<div class="ts-card__body">' +
          '<a href="' + url + '" class="ts-card__title" data-ts-product>' + esc(p.title) + '</a>' +
          '<div class="ts-card__price">' + priceHtml + '</div>' + btn +
        '</div>' +
      '</div>';
    }
    var recoLoaded = false;
    function loadReco() {
      var host = root.querySelector('[data-ts-reco]');
      if (!host || recoLoaded) return;
      recoLoaded = true;
      var handle  = host.getAttribute('data-reco-handle') || 'bestsellers';
      var count   = parseInt(host.getAttribute('data-reco-count'), 10) || 8;
      var heading = host.getAttribute('data-reco-heading') || 'Recommended for you';
      fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + count, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var prods = (d && d.products) || [];
          if (!prods.length) { host.hidden = true; return; }
          var icon = '<svg class="ts-section__icon" viewBox="0 0 20 20" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M3 5h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm4-3h6a1 1 0 0 1 1 1v2H6V3a1 1 0 0 1 1-1z"/></svg>';
          host.innerHTML = '<div class="ts-section__head">' + icon + '<span>' + esc(heading) + '</span></div>' +
            '<div class="ts-reco-row">' + prods.map(renderRecoCard).join('') + '</div>';
          host.hidden = false;
        })
        .catch(function () { host.hidden = true; });
    }
    function renderSuggest(r) {
      if (!r) return '';
      var side = '', main = '', rest = '';
      // Merge BOTH sources: Shopify native query suggestions (handles 1-char typos / catalog
      // compounds) first, then our client-side extraction (prefix + compound-split for no-space
      // typos like "mattelip"). Dedup case-insensitively, cap at 6.
      var nativeQs = (r.queries || []).map(function (q) { return q.text || ''; }).filter(Boolean);
      var ourQs = extractQuerySuggestions(currentQuery, r.products);
      var qs = [], seenQs = {};
      nativeQs.concat(ourQs).forEach(function (s) {
        var key = s.toLowerCase();
        if (!seenQs[key]) { seenQs[key] = 1; qs.push(s); }
      });
      qs = qs.slice(0, 6);
      if (qs.length) {
        side += '<div class="ts-sg ts-sg--qs"><div class="ts-sg__h">Search Terms</div><ul class="ts-sg__qs-list">';
        qs.forEach(function (s) {
          side += '<li><button type="button" class="ts-sg__qs-btn" data-ts-suggest="' + esc(s) + '">' +
            '<svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="9" cy="9" r="6"/><line x1="14" y1="14" x2="19" y2="19"/></svg>' +
            '<span>' + esc(s) + '</span></button></li>';
        });
        side += '</ul></div>';
      }
      if (r.collections && r.collections.length) {
        side += '<div class="ts-sg ts-sg--cols"><div class="ts-sg__h">Collections</div><ul class="ts-sg__col-list">';
        r.collections.forEach(function (c) {
          side += '<li><a href="' + c.url + '" class="ts-sg__col">' + esc(c.title) + '</a></li>';
        });
        side += '</ul></div>';
      }
      if (r.products && r.products.length) {
        main += '<div class="ts-sg ts-sg--products"><div class="ts-sg__h">Products</div><div class="ts-grid">';
        r.products.forEach(function (p) { main += renderCard(p); });
        main += '</div></div>';
        main += '<a href="' + (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search?q=' + encodeURIComponent(currentQuery) + '" class="ts-sg__viewall" data-ts-viewall>View all products</a>';
      }
      if (r.articles && r.articles.length) {
        rest += '<div class="ts-sg"><div class="ts-sg__h">Articles</div><ul class="ts-sg__list">';
        r.articles.forEach(function (a) { rest += '<li><a href="' + a.url + '" class="ts-sg__item ts-sg__item--article">' + esc(a.title) + '</a></li>'; });
        rest += '</ul></div>';
      }
      if (r.pages && r.pages.length) {
        rest += '<div class="ts-sg"><div class="ts-sg__h">Pages</div><ul class="ts-sg__list">';
        r.pages.forEach(function (p) { rest += '<li><a href="' + p.url + '" class="ts-sg__item ts-sg__item--page">' + esc(p.title) + '</a></li>'; });
        rest += '</ul></div>';
      }
      if (!side && !main && !rest) return '<div class="ts-sg__empty">No matches yet — keep typing.</div>';
      var html = '';
      if (side || main) html += '<div class="ts-results">' +
        '<div class="ts-results__side">' + side + '</div>' +
        '<div class="ts-results__main">' + main + '</div>' +
      '</div>';
      html += rest;
      return html;
    }
    function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]); }); }
    function formatMoney(cents) {
      var n = (typeof cents === 'number') ? cents / 100 : parseFloat(String(cents).replace(/[^0-9.]/g,'')) || 0;
      try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: window.Shopify && Shopify.currency && Shopify.currency.active || 'INR' }).format(n); }
      catch (e) { return '₹' + n.toFixed(0); }
    }
    function showToast(msg) {
      var t = document.createElement('div'); t.className = 'ts-toast'; t.textContent = msg;
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('ts-toast--in'); });
      setTimeout(function () { t.classList.remove('ts-toast--in'); setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300); }, 1800);
    }
    function refreshCartCount() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var n = c.item_count || 0;
        document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
          var span = b.querySelector('span[aria-hidden="true"]') || b.querySelector('span') || b;
          span.textContent = n;
        });
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
      }).catch(function () {});
    }
    function addedOk(btn, orig) { btn.textContent = 'Added ✓'; refreshCartCount(); showToast('Added to bag'); setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1400); }
    function addToCart(handle, url, btn, variantId) {
      var orig = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
      // Fast path: variant id known from the index -> add directly, no extra fetch
      if (variantId) {
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }) })
          .then(function (r) { if (r && r.ok) return r.json(); throw 0; })
          .then(function () { addedOk(btn, orig); })
          .catch(function () { btn.textContent = orig; btn.disabled = false; });
        return;
      }
      // Fallback: resolve via product.js (index not loaded / handle missing)
      if (!handle) { window.location.href = url || '/'; return; }
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (pd) {
          var variants = pd.variants || [];
          if (variants.length !== 1) { window.location.href = pd.url || url || ('/products/' + handle); return Promise.reject('nav'); }
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: variants[0].id, quantity: 1 }) });
        })
        .then(function (r) { if (r && r.ok) return r.json(); throw 0; })
        .then(function () { addedOk(btn, orig); })
        .catch(function (e) { if (e === 'nav') return; btn.textContent = orig; btn.disabled = false; });
    }

    var debounceTimer = null;
    input.addEventListener('focus', function () { clearTimers(); openPanel(); });
    // a tap on an already-focused bar fires no 'focus' event, so open on click as well
    input.addEventListener('click', function () { if (panel.hidden) { clearTimers(); openPanel(); } });
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        if (input.value.trim().length >= 2) showPredictive();
        else showStatic();
      }, 180);
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target) && !panel.hidden) { closePanel(); if (document.activeElement === input) input.blur(); } });
    form.addEventListener('submit', function () { pushRecent(input.value); trackSearch(input.value, 'persistent_bar'); });
    panel.addEventListener('click', function (e) {
      var atc = e.target.closest('[data-ts-atc]');
      if (atc) { e.preventDefault(); addToCart(atc.getAttribute('data-ts-handle'), atc.getAttribute('data-ts-url'), atc, atc.getAttribute('data-ts-variant-id')); return; }
      var prod = e.target.closest('[data-ts-product]');
      if (prod) { trackPredictiveClick(input.value.trim(), { url: prod.getAttribute('href'), type: 'product' }); /* allow default navigation */ }
      var sug = e.target.closest('[data-ts-suggest]');
      if (sug) {
        var label = sug.getAttribute('data-ts-suggest');
        var href = sug.getAttribute('data-ts-href');
        var sectionSrc = sug.getAttribute('data-ts-section-src');
        var src = 'popular';
        if (sug.closest('[data-ts-recent-list]')) src = 'recent';
        else if (sug.classList.contains('ts-sg__qs-btn')) src = 'query_suggestion';
        else if (sectionSrc) src = 'section:' + sectionSrc;
        pushRecent(label);
        trackSearch(label, src);
        input.value = label;
        if (href) { window.location.href = href; }
        else { form.submit(); }
        return;
      }
      var pclick = e.target.closest('.ts-sg__item');
      if (pclick) {
        trackPredictiveClick(input.value.trim(), { url: pclick.getAttribute('href'), type: pclick.classList.contains('ts-sg__item--article') ? 'article' : (pclick.classList.contains('ts-sg__item--page') ? 'page' : 'product') });
      }
      var rem = e.target.closest('[data-ts-recent-remove]');
      if (rem) { removeRecent(rem.getAttribute('data-ts-recent-remove')); renderRecent(); }
    });
    if (clearBtn) clearBtn.addEventListener('click', function () { clearRecent(); renderRecent(); });
    var closeBtn = root.querySelector('[data-ts-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { closePanel(); input.blur(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { closePanel(); input.blur(); } });
  }

  function bindTabs() {
    var tabs = document.querySelector('[data-ts-tabs]');
    if (!tabs) return;
    tabs.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ts-tab]');
      if (!t) return;
      var type = t.getAttribute('data-ts-tab');
      var url = new URL(window.location.href);
      url.searchParams.set('type', type);
      window.location.href = url.toString();
    });
  }

  function init() {
    document.querySelectorAll('[data-ts-search]').forEach(initWidget);
    bindTabs();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
